import { InjectionToken } from '@angular/core';

export const DYNAMIC_CLOUD_CUSTOMIZATION = new InjectionToken('DYNAMIC_CLOUD_CUSTOMIZATION');

/**
 * Configuration interface for customizing the DynamicCloud module / components / service.
 * Used to differentiate between the generic and customer specific services and their specific settings.
 *
 * @param displayName - The name to display for service
 * @param name - The name / subdomain of the service
 */
export interface DynamicCloudCustomization {
	displayName: 'Dynamic Cloud' | 'Viridium Cloud';
	name: 'dynamic-cloud' | 'viridium-cloud';
}
